export default __webpack_public_path__ + "static/erinC-693c92b6edf335ce79366e5edcab76db.png";